// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_Level = require("../Ritoppu.Model.Level/index.js");
var Ritoppu_Model_Point = require("../Ritoppu.Model.Point/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Model_Stats = require("../Ritoppu.Model.Stats/index.js");
var Ritoppu_Mutation_Level = require("../Ritoppu.Mutation.Level/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var wavePath = function (origin) {
    return function (dest) {
        return function (cellAvailable) {
            var buildPath = function (pos) {
                return function (step) {
                    return function (distanceMap) {
                        var next = function (p) {
                            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(p)(distanceMap))(new Data_Maybe.Just(step - 1 | 0));
                        };
                        var v = Data_Foldable.find(Data_Foldable.foldableArray)(next)(Ritoppu_Model_Point.adjustPoints(pos));
                        if (step === 1) {
                            return [  ];
                        };
                        if (v instanceof Data_Maybe.Just) {
                            return Data_Array.cons(v.value0)(buildPath(v.value0)(step - 1 | 0)(distanceMap));
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return [  ];
                        };
                        throw new Error("Failed pattern match at Ritoppu.Action.CreatureAct (line 164, column 36 - line 167, column 18): " + [ v.constructor.name ]);
                    };
                };
            };
            var iter = function ($copy_toCheck) {
                return function ($copy_step) {
                    return function ($copy_distanceMap) {
                        var $tco_var_toCheck = $copy_toCheck;
                        var $tco_var_step = $copy_step;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(toCheck, step, distanceMap) {
                            var newPoints = Data_Array.filter(function (point) {
                                return cellAvailable(point) && !Data_Map_Internal.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "y";
                                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                    return "x";
                                }))(Data_Ord.ordInt)))(point)(distanceMap);
                            })(Data_Array.nub(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Ord.ordInt)))(Data_Array.concatMap(Ritoppu_Model_Point.adjustPoints)(toCheck)));
                            var newDistanceMap = Data_Foldable.foldr(Data_Foldable.foldableArray)(function (point) {
                                return Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "y";
                                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                    return "x";
                                }))(Data_Ord.ordInt)))(point)(step);
                            })(distanceMap)(newPoints);
                            if (Data_Array["null"](toCheck)) {
                                $tco_done = true;
                                return Data_Maybe.Nothing.value;
                            };
                            if (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                                return "y";
                            }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                                return "x";
                            }))(Data_Eq.eqInt)))(dest))(newPoints)) {
                                $tco_done = true;
                                return new Data_Maybe.Just(Data_Array.cons(dest)(buildPath(dest)(step)(distanceMap)));
                            };
                            if (Data_Boolean.otherwise) {
                                $tco_var_toCheck = newPoints;
                                $tco_var_step = step + 1 | 0;
                                $copy_distanceMap = newDistanceMap;
                                return;
                            };
                            throw new Error("Failed pattern match at Ritoppu.Action.CreatureAct (line 146, column 35 - line 149, column 62): " + [ Data_Unit.unit.constructor.name ]);
                        };
                        while (!$tco_done) {
                            $tco_result = $tco_loop($tco_var_toCheck, $tco_var_step, $copy_distanceMap);
                        };
                        return $tco_result;
                    };
                };
            };
            return iter([ origin ])(1)(Data_Map_Internal.singleton(origin)(0));
        };
    };
};
var moveForward = function (origin) {
    return function (v) {
        var cellAvailable = function (dest) {
            return Ritoppu_Model_Stage.availableToMoveTo(v)(dest);
        };
        var v1 = wavePath(origin)(v.player.pos)(cellAvailable);
        if (v1 instanceof Data_Maybe.Just) {
            var v2 = Data_Array.last(v1.value0);
            if (v2 instanceof Data_Maybe.Just && !Ritoppu_Model_Stage.anybodyAt(v)(v2.value0)) {
                return v2.value0;
            };
            return origin;
        };
        return origin;
    };
};
var acted = function (c) {
    return {
        type: c.type,
        stats: c.stats,
        turn: c.turn + 5 | 0,
        aiStrategy: c.aiStrategy,
        xp: c.xp
    };
};
var attack = function (v) {
    return function (result) {
        var withActedCreature = Ritoppu_Action.onResult(function (game) {
            return {
                stage: Ritoppu_Mutation_Stage.updateCreature(v.value0)(acted)(game.stage),
                dungeonLevel: game.dungeonLevel
            };
        })(result);
        var damage = Ritoppu_Model_Stats.damageTo(v.value1.stats)(result.result.stage.player.stats);
        if (damage === 0) {
            return actNext(Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.DamageYouHarmlessM(v.value1)))(withActedCreature));
        };
        if (damage >= result.result.stage.player.stats.hp) {
            return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.DamageYouM(v.value1, damage)))(Ritoppu_Action.die(Ritoppu_Action.onResult(function (game) {
                return {
                    stage: {
                        player: {
                            stats: Ritoppu_Mutation_Stats.takeDamage(damage)(game.stage.player.stats),
                            equipment: game.stage.player.equipment,
                            inventory: game.stage.player.inventory,
                            level: game.stage.player.level,
                            pos: game.stage.player.pos,
                            turn: game.stage.player.turn
                        },
                        creatures: game.stage.creatures,
                        fovMask: game.stage.fovMask,
                        items: game.stage.items,
                        seen: game.stage.seen,
                        size: game.stage.size,
                        tiles: game.stage.tiles
                    },
                    dungeonLevel: game.dungeonLevel
                };
            })(withActedCreature)));
        };
        return actNext(Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.DamageYouM(v.value1, damage)))(Ritoppu_Action.onResult(function (game) {
            return {
                stage: {
                    player: {
                        stats: Ritoppu_Mutation_Stats.takeDamage(damage)(game.stage.player.stats),
                        equipment: game.stage.player.equipment,
                        inventory: game.stage.player.inventory,
                        level: game.stage.player.level,
                        pos: game.stage.player.pos,
                        turn: game.stage.player.turn
                    },
                    creatures: game.stage.creatures,
                    fovMask: game.stage.fovMask,
                    items: game.stage.items,
                    seen: game.stage.seen,
                    size: game.stage.size,
                    tiles: game.stage.tiles
                },
                dungeonLevel: game.dungeonLevel
            };
        })(withActedCreature)));
    };
};
var actNext = function (v) {
    var creaturesToAct = Data_Array.filter(function (v1) {
        return v.result.stage.player.turn > v1.value1.turn;
    })(Data_Map_Internal.toUnfoldableUnordered(Data_Unfoldable.unfoldableArray)(v.result.stage.creatures));
    var v1 = Data_Array.head(creaturesToAct);
    if (v1 instanceof Data_Maybe.Just) {
        return actCreature(v1.value0)(v);
    };
    if (v1 instanceof Data_Maybe.Nothing) {
        return v;
    };
    throw new Error("Failed pattern match at Ritoppu.Action.CreatureAct (line 27, column 35 - line 29, column 20): " + [ v1.constructor.name ]);
};
var actCreature = function (v) {
    return function (result) {
        var dy = (function () {
            if (Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v.value0.x)(3) === 0) {
                return 1;
            };
            if (Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v.value0.x)(5) === 0) {
                return -1 | 0;
            };
            return 0;
        })();
        var dx = (function () {
            if (Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v.value0.y)(3) === 0) {
                return 1;
            };
            if (Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v.value0.y)(5) === 0) {
                return -1 | 0;
            };
            return 0;
        })();
        var randomDest = Data_Ring.sub(Data_Ring.ringRecord()(Data_Ring.ringRecordCons(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))()(Data_Ring.ringRecordCons(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))()(Data_Ring.ringRecordNil)(Data_Ring.ringInt))(Data_Ring.ringInt)))(v.value0)({
            x: dx,
            y: dy
        });
        if (v.value1.aiStrategy instanceof Ritoppu_Model_Creature.ConfusedAI && v.value1.aiStrategy.value0 === 0) {
            return actNext(Ritoppu_Action.onResult(function (g) {
                return {
                    stage: Ritoppu_Mutation_Stage.updateCreature(v.value0)(function (c) {
                        return {
                            type: c.type,
                            stats: c.stats,
                            turn: c.turn,
                            aiStrategy: v.value1.aiStrategy.value1,
                            xp: c.xp
                        };
                    })(g.stage),
                    dungeonLevel: g.dungeonLevel
                };
            })(result));
        };
        if (v.value1.aiStrategy instanceof Ritoppu_Model_Creature.ConfusedAI) {
            if (Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Eq.eqInt)))(result.result.stage.player.pos)(randomDest)) {
                return attack(v)(Ritoppu_Action.onResult(function (g) {
                    return {
                        stage: Ritoppu_Mutation_Stage.updateCreature(v.value0)(function (c) {
                            return {
                                type: c.type,
                                stats: c.stats,
                                turn: c.turn,
                                aiStrategy: new Ritoppu_Model_Creature.ConfusedAI(v.value1.aiStrategy.value0 - 1 | 0, v.value1.aiStrategy.value1),
                                xp: c.xp
                            };
                        })(g.stage),
                        dungeonLevel: g.dungeonLevel
                    };
                })(result));
            };
            if (Ritoppu_Model_Stage.anybodyAt(result.result.stage)(randomDest)) {
                return actNext(Ritoppu_Action.onResult(function (g) {
                    return {
                        stage: Ritoppu_Mutation_Stage.updateCreature(v.value0)(function (c) {
                            return acted({
                                type: c.type,
                                stats: c.stats,
                                turn: c.turn,
                                aiStrategy: new Ritoppu_Model_Creature.ConfusedAI(v.value1.aiStrategy.value0 - 1 | 0, v.value1.aiStrategy.value1),
                                xp: c.xp
                            });
                        })(g.stage),
                        dungeonLevel: g.dungeonLevel
                    };
                })(result));
            };
            if (Ritoppu_Model_Stage.availableToMoveTo(result.result.stage)(randomDest)) {
                return actNext(Ritoppu_Action.onResult(function (game) {
                    return {
                        stage: Ritoppu_Mutation_Stage.moveCreature(v.value0)(randomDest)(acted({
                            type: v.value1.type,
                            stats: v.value1.stats,
                            turn: v.value1.turn,
                            aiStrategy: new Ritoppu_Model_Creature.ConfusedAI(v.value1.aiStrategy.value0 - 1 | 0, v.value1.aiStrategy.value1),
                            xp: v.value1.xp
                        }))(game.stage),
                        dungeonLevel: game.dungeonLevel
                    };
                })(result));
            };
            return actNext(Ritoppu_Action.onResult(function (g) {
                return {
                    stage: Ritoppu_Mutation_Stage.updateCreature(v.value0)(function (c) {
                        return acted({
                            type: c.type,
                            stats: c.stats,
                            turn: c.turn,
                            aiStrategy: new Ritoppu_Model_Creature.ConfusedAI(v.value1.aiStrategy.value0 - 1 | 0, v.value1.aiStrategy.value1),
                            xp: c.xp
                        });
                    })(g.stage),
                    dungeonLevel: g.dungeonLevel
                };
            })(result));
        };
        if (Ritoppu_Model_Point.isNextTo(v.value0)(result.result.stage.player.pos)) {
            return attack(v)(result);
        };
        return actNext(Ritoppu_Action.onResult(function (game) {
            return {
                stage: Ritoppu_Mutation_Stage.moveCreature(v.value0)(moveForward(v.value0)(game.stage))(acted(v.value1))(game.stage),
                dungeonLevel: game.dungeonLevel
            };
        })(result));
    };
};
var creatureAct = function (game) {
    var $61 = Ritoppu_Model_Level.isReadyToLevelUp(game.stage.player.level)(0);
    if ($61) {
        return Ritoppu_Action.openLevelUp(Ritoppu_Action.inactive({
            stage: {
                player: {
                    level: Ritoppu_Mutation_Level.levelIncrease(0)(game.stage.player.level),
                    equipment: game.stage.player.equipment,
                    inventory: game.stage.player.inventory,
                    pos: game.stage.player.pos,
                    stats: game.stage.player.stats,
                    turn: game.stage.player.turn
                },
                creatures: game.stage.creatures,
                fovMask: game.stage.fovMask,
                items: game.stage.items,
                seen: game.stage.seen,
                size: game.stage.size,
                tiles: game.stage.tiles
            },
            dungeonLevel: game.dungeonLevel
        }));
    };
    return actNext(Ritoppu_Action.inactive(game));
};
module.exports = {
    creatureAct: creatureAct,
    wavePath: wavePath
};
